// IMPORTANT: THIS FILE IS AUTO GENERATED!

/**
 * Package version.
 */
exports.version = '6.0.7-hf2';

/**
 * Timestamp.
 */
exports.timestamp = '1744412971791';

/**
 * ISO date and time.
 */
exports.dateTime = '2025-04-11T23:09:31.791Z';

/**
 * Git hash.
 */
exports.gitHash = '3498014188aaaf0c878da36d9e7bf5d7c7c1255e';

/**
 * Git short hash.
 */
exports.gitHashShort = '349801418';

/**
 * Git tag name.
 */
exports.gitTag = 'v5.5.0';

/**
 * Git branch name.
 */
exports.gitBranch = 'release-6.0.7-hf2';
